export class PractitionerSymptomsUpdate {
    practitionerId: number;
    symptomIds: number[];
}
